var map = {
	"./commercial/routes.js": "985b",
	"./feed/routes.js": "07e9",
	"./lead/routes.js": "5cc1",
	"./product/routes.js": "b148",
	"./reports/routes.js": "bba4",
	"./representative/routes.js": "6ac1",
	"./reseller/routes.js": "6700",
	"./settings/routes.js": "de76",
	"./user/routes.js": "2e02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74855";